<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title> Daily Routine </mat-panel-title>
    <mat-panel-description>
      <!-- <img [src]="personal" /> -->
    </mat-panel-description>
  </mat-expansion-panel-header>
  <div class="spinner" *ngIf="dailyRoutine === undefined">
    <mat-spinner mode="indeterminate"></mat-spinner>
  </div>
  <div class="expansion-content" *ngIf="dailyRoutine !== undefined">
    <div class="cell">
      <label>Wakeup Time : </label>
      <span>{{ dailyRoutine.wakeupTime }}</span>
    </div>
    <div class="cell">
      <label>Start Work Time : </label>
      <span>{{ dailyRoutine.startWorkTime }}</span>
    </div>
    <div class="cell">
      <label>End Work Time : </label>
      <span>{{ dailyRoutine.endWorkTime }}</span>
    </div>
    <div class="cell">
      <label>Sleep Hours : </label>
      <span>{{ dailyRoutine.sleepHours }}</span>
    </div>
    <div class="cell">
      <label>Breakfast : </label>
      <span>{{ dailyRoutine.breakfast }}</span>
    </div>
    <div class="cell">
      <label>Breakfast Time : </label>
      <span>{{ dailyRoutine.breakfastTime }}</span>
    </div>
    <div class="cell">
      <label>Lunch: </label>
      <span>{{ dailyRoutine.lunch }}</span>
    </div>
    <div class="cell">
      <label>Lunch Time : </label>
      <span>{{ dailyRoutine.lunchTime }}</span>
    </div>
    <div class="cell">
      <label>Dinner : </label>
      <span>{{ dailyRoutine.dinner }}</span>
    </div>
    <div class="cell">
      <label>Dinner Time : </label>
      <span>{{ dailyRoutine.dinnerTime }}</span>
    </div>
    <div class="cell">
      <label>Mid Meal Snacks : </label>
      <span>{{ dailyRoutine.midMealSnacks }}</span>
    </div>
    <div class="cell">
      <label>Mid Meal Snacks Time : </label>
      <span>{{ dailyRoutine.midMealSnacksTime }}</span>
    </div>
    <div class="cell">
      <label>weekend Routine : </label>
      <span>{{ dailyRoutine.weekends }}</span>
    </div>
    <div class="cell">
      <label>Workout Routine : </label>
      <span>{{ dailyRoutine.workoutRoutine }}</span>
    </div>
    <div class="cell">
      <label>Housewife Routine : </label>
      <span>{{ dailyRoutine.housewifeRoutine }}</span>
    </div>
    <div class="cell">
      <label>Other Diet : </label>
      <span>{{ dailyRoutine.otherDiet }}</span>
    </div>
    <div class="cell">
      <label>Anything Else : </label>
      <span>{{ dailyRoutine.anything }}</span>
    </div>
  </div>
</mat-expansion-panel>
